import PagedElements from '@/models/paged/pagedelements'
import PriceListListViewModel from '../view/pricelistlistviewmodel'

export default class PagedPriceLists extends PagedElements<PriceListListViewModel> {
  constructor(init?: Partial<PagedPriceLists>) {
    super(init)
  }
}
